<template>
  <div class="container logged-out-content">
    <div class="block form-md">
      <header>
        <div class="pull-left">
          <div class="icon">
            <img src="~assets/images/Patient-Icon.png">
          </div>
        </div>
        <div class="col-xs-9">
          <h2>Signup</h2>
        </div>
      </header>

      <div class="content text-bold text-center h4">
        Please select the product you would like to sign-up for:
      </div>

      <context-selector></context-selector>

      <keep-alive>
        <component :is="currentForm"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import ContextSelector from 'components/common/ContextSelector';

  import AcademicForm from 'components/user/forms/AcademicForm';
  // TODO: Reintroduce PatientForm When a patient is pointed to version 2
  // import PatientForm from 'components/user/forms/PatientForm';
  import UnderConstructionDisplay from 'components/common/outputs/UnderConstructionDisplay';
  import PracticeForm from 'components/user/forms/PracticeForm';
  import ErrorDisplay from 'components/common/outputs/ErrorDisplay';

  export default {
    name: 'sign-up',
    data: () => ({
      links: {
        andriod: `${process.env.VUE_APP_PATIENT_APP_ANDROID}`,
        apple: `${process.env.VUE_APP_PATIENT_APP_ISO}`,
      },
    }),
    props: ['signupContext'],
    components: {
      ContextSelector,
      AcademicForm,
      PracticeForm,
      ErrorDisplay,
      // TODO: Reintroduce PatientForm When a patient is pointed to version 2
      // PatientForm,
      UnderConstructionDisplay,
    },
    computed: {
      currentForm() {
        switch (this.context) {
          case 'patient':
            // TODO: Reintroduce PatientForm When a patient is pointed to version 2
            // return 'PatientForm';
            return 'UnderConstructionDisplay';
          case 'practice':
            return 'PracticeForm';
          case 'academic':
            return 'AcademicForm';
          default:
            // TODO: Reintroduce PatientForm When a patient is pointed to version 2
            // return 'PatientForm';
            return 'UnderConstructionDisplay';
        }
      },
      ...mapState([
        'context',
      ]),
    },
    mounted() {
      if (this.signupContext && (
          this.signupContext === 'patient' ||
          this.signupContext === 'practice' ||
          this.signupContext === 'academic'
        )) {
        this.$store.dispatch('updateContext', {
          context: this.signupContext,
        });
      } else if (this.$store.state.context === '') {
        // If no context is found, set context to patient
        this.$store.dispatch('updateContext', {
          context: 'patient',
        });
      }
    },
  };

</script>



// WEBPACK FOOTER //
// SignUp.vue?1e016bc8